import React, { useMemo } from "react";
import { injectIntl } from "react-intl";

const GoBack = (props) => {
  const { panel, updateState, intl } = props;
  const { formatMessage } = intl;

  const _goBack = () => {
    let events = props.currentState.events;
    let backStatus = props.currentState?.backStatus;
    const stepBack = backStatus.history?.pop();
    events["main"] = events[panel.allowBack.event];
    if (panel.allowBack.save) {
      events["main"].back = true;
    }

    updateState("backStatus", {
      history: backStatus?.history,
    });

    if (panel.allowBack.value === "useHistory" && stepBack) {
      updateState("primary", stepBack?.primaryState);
      events.main = stepBack?.event;
    } else {
      updateState(panel.allowBack.state, panel.allowBack.value);
    }

    updateState("events", events);
  };

  const isBackstepEmpty = useMemo(() => {
    if (panel.allowBack.value !== "useHistory") {
      return false;
    }
    let backStatus = props.currentState?.backStatus;
    if (!backStatus) {
      return false;
    }
    const stepBack = backStatus.history?.at(-1);
    if (!stepBack) {
      return true;
    }
    return !stepBack.primaryState || stepBack.primaryState === "main-buttons";
  }, [props.currentState?.backStatus, panel.allowBack.value]);

  return (
    !isBackstepEmpty && (
      <div className="go-back" onClick={() => _goBack()}>
        <i className="fas fa-angle-left"></i>
        <span>
          {formatMessage({
            id: "back",
            defaultMessage: "back",
          })}
        </span>
      </div>
    )
  );
};

export default injectIntl(GoBack);
